"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _styles = require("../styles");

function ErrorIcon(a) {
  var b = a.className,
      c = a.errorMessage,
      d = a.size,
      e = a.id,
      f = a.tooltipProps;
  f = void 0 === f ? {} : f;
  var g = f.place;
  return _react["default"].createElement(_Icon["default"], {
    color: "thunderBird",
    className: b,
    name: "alert",
    size: d,
    tooltipId: c ? e : void 0,
    tooltipLabel: c,
    tooltipPlace: g,
    tooltipClass: _styles.ERROR_TOOLTIP
  });
}

ErrorIcon.defaultProps = {
  tooltipProps: {},
  size: 15
};

var _default = (0, _react.memo)(ErrorIcon);

exports["default"] = _default;